import React from 'react';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';

import ANALYTICS_CATEGORIES from '../../analytics/categories';
import { Content } from '../../components/shared/Content';
import ScrollToTop from '../../components/shared/ScrollToTop';
import { SigningContextProvider } from '../../signingContext/signingContext';
import { AddUserToEfaktura } from './components/AddUserToEfaktura';
import { EfakturaSelectList } from './components/EfakturaSelectList';
import { SharedEfakturaList } from './components/SharedEfakturaList';
import { Summary } from './components/Summary';
import { UpdatePermission } from './components/UpdatePermission';
import efakturaSharingReducer from './form/reducer';
import { initialEfakturaSharingState } from './form/state';
import { EfakturaSharingFormContext } from './form/useFormContext';
import useValidate from './form/validate';
import routes from './routes';

import './EfakturaSharing.scss';

const EfakturaSharing: React.FC = () => {
    return (
        <Content className="efaktura-sharing">
            <SigningContextProvider analyticsCategory={ANALYTICS_CATEGORIES.SHARE_EFAKTURA}>
                <EfakturaSharingFormContext
                    validateHook={useValidate}
                    reducer={efakturaSharingReducer}
                    initialState={initialEfakturaSharingState}
                >
                    <Router>
                        <ScrollToTop />
                        <Routes>
                            <Route path={routes['efaktura-list']} Component={EfakturaSelectList} />
                            <Route path={routes['choose-person']} Component={AddUserToEfaktura} />
                            <Route path={routes.summary} Component={Summary} />
                            <Route path={`${routes.update}/:efakturaId`} Component={UpdatePermission} />
                            <Route path={routes.home} Component={SharedEfakturaList} />
                        </Routes>
                    </Router>
                </EfakturaSharingFormContext>
            </SigningContextProvider>
        </Content>
    );
};

export default EfakturaSharing;
